import { ThemeProvider } from '@emotion/react';
import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { createTheme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import * as React from 'react';

const colortheme = createTheme({
  palette: {
    error: {
      main: '#c1c1c1',
    },
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#c1c1c1',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '14px',
    },
  },
})(TextField);

interface INormalSearchInput {
  placeholder: string;
  onChange: (query: any) => void;
}

const NormalSearchInput: React.FC<INormalSearchInput> = ({
  placeholder,
  onChange,
}) => {
  return (
    <ThemeProvider theme={colortheme}>
      <Paper
        component="form"
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '55px',
          backgroundColor: 'rgba(255,255,255,0.16862745098039217 )',
          borderRadius: '20px',
          boxShadow: 'none',
        }}
      >
        <IconButton
          type="submit"
          sx={{ color: '#c1c1c1', padding: '10px' }}
          aria-label="search"
        >
          <SearchIcon style={{ fontSize: '30px' }} />
        </IconButton>
        <WhiteTextField
          // {...params}
          sx={{
            ml: 1,
            flex: 1,
            color: '#ffffff',
            height: '55px',
            padding: 'unset',
            margin: 'unset',
            fontSize: '14px',
            border: 'none',
            '& .MuiOutlinedInput-root fieldset': {
              border: 'none',
            },
          }}
          placeholder={placeholder}
          InputProps={{
            type: 'search',
          }}
          onChange={onChange}
        />
      </Paper>
    </ThemeProvider>
  );
};

export default NormalSearchInput;
